import {
  Sliders,
  Users,
  UserPlus,
  ChevronsUp,
  DollarSign,
  FileText,
  Grid,
  TrendingUp,
  PieChart,
  Activity,
  ShoppingBag,
} from 'react-feather';

/**
 * Sprint 2 salesperson sidebar.
 *
 * Salespersons see a filtered CRM section (own customers/abonnemang via
 * server-side filters) and a Leverans section limited to kundlista. They
 * have no access to Drift & administration. Legacy entries are kept below
 * for now so existing flows don't break.
 */

const dashboardSection = {
  title: '',
  pages: [
    {
      href: '/salesperson/dashboard/default',
      title: 'Dashboard',
      icon: Sliders,
    },
  ],
};

const crmSection = {
  title: 'CRM - Försäljning',
  pages: [
    {
      href: '/salesperson/crm/saljardashboard',
      title: 'Min dashboard',
      icon: PieChart,
    },
    {
      href: '/salesperson/crm/pipeline',
      title: 'Pipeline',
      icon: TrendingUp,
    },
    {
      href: '/salesperson/crm/abonnemang',
      title: 'Abonnemang',
      icon: ShoppingBag,
    },
    {
      href: '/salesperson/invoices',
      title: 'Fakturor',
      icon: DollarSign,
    },
    {
      href: '/salesperson/fakturalista',
      title: 'Fakturalista',
      icon: FileText,
    },
    {
      href: '/salesperson/proposal',
      title: 'Proposals',
      icon: ChevronsUp,
    },
    {
      href: '/salesperson/crm/retention',
      title: 'Retention',
      icon: Activity,
    },
    {
      href: '/salesperson/crm/aktivitet',
      title: 'Aktiviteter',
      icon: Activity,
    },
    {
      href: '/salesperson/crm/arr-budget',
      title: 'ARR mot budget',
      icon: TrendingUp,
    },
  ],
};

const leveransSection = {
  title: 'Leverans',
  pages: [
    {
      href: '/salesperson/leverans/kundlista',
      title: 'Kundlista',
      icon: Users,
    },
    {
      href: '/salesperson/leads',
      title: 'Kundförfrågningar',
      icon: UserPlus,
    },
    {
      href: '/salesperson/kundföretag',
      title: 'Kundföretag',
      icon: Users,
    },
  ],
};

const legacySection = {
  title: 'Legacy',
  pages: [
    {
      href: '/salesperson/produkter',
      title: 'Produkter',
      icon: Grid,
      children: [
        { href: '/salesperson/sites', title: 'Landningssidor' },
        { href: '/salesperson/hemsidor', title: 'Hemsidor' },
      ],
    },
    {
      href: '/salesperson/client',
      title: 'Inlogg kunder',
      icon: Users,
    },
    {
      href: '/salesperson/users',
      title: 'Användare (legacy)',
      icon: Users,
    },
  ],
};

const navItems = [dashboardSection, crmSection, leveransSection, legacySection];

export default navItems;
